<template>
  <div :class="[$setClasses, $vPrefix('--margin-top-default')]">
    <nxt-core-html-content>
      <template v-if="computedBeforeContent"
                v-slot:beforeContent>
        <div :class="displayConfirmVisio && $vClass('meeting')"
             v-html="computedBeforeContent">
        </div>
      </template>
      <nxt-core-card v-if="displayConfirmVisio && formatDate"
                     :class="$vClass('meeting__calendar')">
        <div :class="$vClass('meeting__calendar__content')"
             v-html="$t('meeting.confirmDate', {
               day: formatDate.day,
               hoursStart: formatDate.hoursStart,
               hoursEnd: formatDate.hoursEnd,
               month: formatDate.month,
               weekday: formatDate.weekday,
             })"></div>
      </nxt-core-card>
      <template v-if="field?.cards?.length">
        <nxt-core-card v-for="(card, index) in field.cards"
                       :key="index"
                       :class="$vPrefix('--margin-top-default')"
                       :icon="card.icon"
                       :title="card.title">
          <div v-html="card.content"></div>
        </nxt-core-card>
      </template>
      <template v-if="computedAfterContent"
                v-slot:afterContent>
        <div v-html="computedAfterContent"></div>
      </template>
    </nxt-core-html-content>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { usePartnerStore } from '../../../store/partnerStore.ts';

export default {
  nameClassStyle: 'confirm',
  name: 'Confirm',
  props: {
    beforeContent: String,
    afterContent: String,
    field: Object,
  },
  computed: {
    ...mapState(usePartnerStore, [
      'typeMeeting',
      'meetingInfos',
      'currentStep',
    ]),
    computedBeforeContent() {
      return this.beforeContent || this.field.before_content;
    },
    computedAfterContent() {
      return this.afterContent || this.field.after_content;
    },
    displayConfirmVisio() {
      return this.typeMeeting?.value === 'VISIO';
    },
    formatDate() {
      if (this.meetingInfos?.start && this.meetingInfos?.end) {
        const dateStart = new Date(this.meetingInfos.start);
        const dateEnd = new Date(this.meetingInfos.end);
        const timeZone = this.$t('base.timeZone');
        return {
          weekday: new Intl.DateTimeFormat(timeZone, { weekday: 'long' }).format(dateStart),
          day: new Intl.DateTimeFormat(timeZone, { day: 'numeric' }).format(dateStart),
          month: new Intl.DateTimeFormat(timeZone, { month: 'long' }).format(dateStart),
          year: new Intl.DateTimeFormat(timeZone, { year: 'numeric' }).format(dateStart),
          hoursStart: this.$helpers.format.formatHours(dateStart),
          hoursEnd: this.$helpers.format.formatHours(dateEnd),
        };
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
$prefixClass: #{$prefixName}confirm;
$meetingClass: #{$prefixClass}__meeting;
$calendarContentClass: #{$meetingClass}__calendar__content;

.#{$prefixClass},
:deep(.#{$prefixClass}) {
  ul {
    padding: 0;
  }

  li {
    list-style: none;
  }

  .#{$prefixClass}--margin-top-default {
    margin-top: var(--nxt-space-default);
  }

  .#{$prefixClass}__card {
    @include breakpoint(tablet) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: var(--nxt-space-xxlarge);
    }

    &__item {
      text-align: center;
      padding-top: var(--nxt-space-small);

      @include breakpoint(tablet) {
        padding-top: 0;
      }

      &__title {
        font-size: var(--nxt-font-size-medium);
        font-weight: var(--nxt-font-weight-bold);
      }
    }
  }
}

.#{$prefixClass} {
  :deep(p) {
    font-size: var(--nxt-font-size-medium);
  }
}

:deep(.#{$prefixClass}__title) {
  font-size: var(--nxt-font-size-xlarge);
}

:deep(.#{$prefixClass}__link) {
  border-bottom: 0.1rem solid;
  text-shadow: var(--nxt-text-shadow-primary);
  font-weight: var(--nxt-font-weight-bold);
  color: var(--nxt-color-secondary);
  text-decoration: none;
}

:deep(.#{$prefixClass}__img) {
  display: block;
  margin: var(--nxt-space-xxlarge) auto;
}

:deep(.nxt-confirm__meeting__infos__image) {
  margin: var(--nxt-space-default) auto;
  text-align: center;
}

.#{$meetingClass} {
  text-align: center;
  font-weight: var(--nxt-font-weight-bold);

  :deep(.#{$meetingClass}__icon) {
    color: #1cdba1;
  }

  :deep(.#{$meetingClass}__subtitle) {
    padding-bottom: var(--nxt-space-large);
    font-weight: lighter;
  }

  :deep(.#{$meetingClass}__infos) {
    margin-top: var(--nxt-space-xxlarge);

    .#{$meetingClass}__infos__image {
      margin: var(--nxt-space-default) auto;
      text-align: center;
    }
  }

  &__calendar {
    font-weight: var(--nxt-font-weight-bold);
    margin: 0 auto 40px;

    :deep(.#{$calendarContentClass}) {
      text-align: center;
      text-transform: uppercase;

      .#{$calendarContentClass}__item {
        &:first-child {
          background: url(../../../assets/img/calendar.png) no-repeat;
          height: 132px;
          width: 100px;
          margin: 0 auto 20px auto;
        }

        &__month {
          position: relative;
          top: 35px;
          width: 90px;
          font-size: 13px;
          color: #fff;
        }

        &__day {
          position: relative;
          top: 47px;
          width: 90px;
          font-size: 40px;
          color: #253163;
        }
      }
    }

    @include breakpoint(tablet) {
      width: 450px;

      :deep(.#{$calendarContentClass}) {
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .#{$calendarContentClass}__item {
          &:first-child {
            padding-bottom: 0;
            padding-right: 10px;
            margin: 0;
          }

          &:nth-child(2) {
            padding-left: var(--nxt-space-large);
          }
        }
      }
    }
  }
}
</style>
